// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import {
  // DefaultPage,
  Home,
  CourseManage,
  ClassRecord,
  StartExer,
  ExerRecord,
  MyOrder,
  Account,
  Message,
  Coupon,
} from './';
import loadable from "../../utils/loadable"
const LoadDefaultPage = loadable(() => import('../center/DefaultPage'));

export default {
  path: 'center',
  name: 'Center',
  component: LoadDefaultPage,
  childRoutes: [
    { path: '', name: 'Home', component: Home, isIndex: true },
    { path: 'courseManage/:id', name: 'Course manage', component: CourseManage },
    { path: 'classRecord/:id', name: 'Class record', component: ClassRecord },
    { path: 'startExer/:id', name: 'Start exer', component: StartExer },
    { path: 'exerRecord/:id', name: 'Exer record', component: ExerRecord },
    { path: 'myOrder/:id', name: 'My order', component: MyOrder },
    { path: 'account/:id', name: 'Account', component: Account },
    { path: 'message/:id', name: 'Message', component: Message },
    { path: 'coupon/:id', name: 'Coupon', component: Coupon },
  ],
};



// WEBPACK FOOTER //
// ./src/features/center/route.js